module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "adc",
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "adc"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page iii. ",
      "epub:type": "pagebreak",
      "id": "pg_iii",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', [_c('b', [_vm._v("ALSO BY KEN KALFUS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("Coup de Foudre: A Novella and Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("Equilateral: A Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("A Disorder Peculiar to the Country: A Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("The Commissariat of Enlightenment: A Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("Pu-239 and Other Russian Fantasies:")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("A Novella and Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "TC"
  }, [_c('i', [_vm._v("Thirst: Stories")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d16591","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/adcard.vue
// module id = 57
// module chunks = 0